import {Button, Modal, Upload, Radio, message, Popconfirm, Spin} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React, {useState} from 'react';
import {downloadFile} from '../../common/helpers/downloadFile';
import {apiUrl} from '../../app.config';
import {getToken} from '../../security';

const { Dragger } = Upload;

export const UploadTraspasos = ({ open, onCancel, distributionPointId }) => {

    const [ loading, setLoading ] = useState(false);
    const [importMethod, setImportMethod] = useState('archivo');

    const handleRadioChange = (e) => {
        setImportMethod(e.target.value);
    };

    const beforeUpload = (file) => {
        const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');
        const isXLS = file.type === 'application/vnd.ms-excel' || file.name.endsWith('.xls') || file.name.endsWith('.xlsx');
        if (!isCSV && !isXLS) {
            message.error('Solo se pueden cargar archivos CSV o XLS');
        }
        return isCSV || isXLS;
    };

    const handleUploadChange = ({ fileList }) => {
        if (fileList.length > 0) {
            message.success(`${fileList.length} archivo(s) cargado(s) correctamente.`);
        }
    };

    const onConfirm = async () => {
        console.log('onConfirmed cliked')
    }

    const downloadTemplate = () => {
        downloadFile({
            url: `${apiUrl}${distributionPointId}/template/traspasos`,
            headers: {
                Authorization: getToken(),
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/json'
            },
            defaultFileName: 'plantilla-traspasos.xlsx',
            onStart: () => setLoading(true),
            onFinish: () => setLoading(false),
        });
    };

    return (
        <div>
            <Modal
                title="Importar Traspasos"
                open={open}
                onCancel={onCancel}
                footer={[
                    <Button key="back" onClick={onCancel}>
                        Cancelar
                    </Button>,
                    <Popconfirm
                        title={`Cargar archivo`}
                        key="confirm"
                        onConfirm={onConfirm}
                        okText="Sí"
                        cancelText="No"
                    >
                        <Button icon={<Upload />} disabled key="submit" type="primary">
                            Cargar archivo
                        </Button>
                    </Popconfirm>
                ]}
                width={600}
            >
                <Spin tip="Descargando plantilla..." spinning={loading}>
                    <p>Seleccione el método de importación y cargue los datos de traspasos.</p>
                    <Radio.Group value={importMethod} onChange={handleRadioChange}>
                        <Radio value="archivo">Importar desde archivo</Radio>
                        <Radio value="g4s">Importar desde G4S</Radio>
                    </Radio.Group>

                    <div style={{ marginTop: 20 }}>
                    {importMethod === 'archivo' && (
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                <p style={{ marginRight: '10px', marginBottom: 0 }}>Descargue la plantilla para asegurar el formato correcto</p>
                                <Button download onClick={downloadTemplate}>
                                    Descargar plantilla
                                </Button>
                            </div>

                            <Dragger
                                accept=".csv,.xls,.xlsx"
                                beforeUpload={beforeUpload}
                                disabled
                            >
                                <p className="ant-upload-drag-icon">
                                    <UploadOutlined />
                                </p>
                                <p className="ant-upload-text">Haga clic para cargar o arrastre y suelte</p>
                                <p className="ant-upload-hint">
                                    Solo archivos CSV o XLSX(Máx 20MB)
                                </p>
                            </Dragger>
                        </div>
                    )}
                    {importMethod === 'g4s' && (
                        <div>
                            <Button disabled block>
                                Importar desde G4S
                            </Button>
                        </div>
                    )}
                </div>
                </Spin>
            </Modal>
        </div>
    );

}